const dictionary = {
	Login: {
		en: {
			"welcome to metibox": "welcome to metibox",
			email: "email",
			password: "password",
			login: "login",
			"remember me": "Remember me",
			"forgot password?": "Forgot Password?",
			"invalid email address or password": "invalid email address or password",
		},
		fr: {
			"welcome to metibox": "bienvenue sur Meti-box",
			email: "adresse email",
			password: "mot de passe",
			login: "se connecter",
			"remember me": "Souviens-toi de moi",
			"forgot password?": "mot de passe oublié?",
			"invalid email address or password": "adresse email ou mot de passe invalide ",
		},
	},
	ForgotPassword: {
		en: {
			"reset your password": "reset your password",
			"username or email": "Username or Email",
			confirm: "CONFIRM",
			"Invalid email address": "invalid email address",
			"Invalid verification code": "Invalid verification code",
		},
		fr: {
			"reset your password": "réinitialiser votre mot de passe",
			"username or email": "Nom d’utilisateur ou email",
			confirm: "CONFIRMER",
			"invalid email address": "adresse email non valide",
			"Invalid verification code": "code de vérification invalide",
		},
	},
	Sidebar: {
		en: {
			Home: "Home",
			Chat: "Chat",
			Invoices: "Invoices",
			Trash: "Trash",
		},
		fr: {
			Home: "Page d’accueil",
			Chat: "Bavarder",
			Invoices: "Factures",
			Trash: "Les déchets",
		},
	},
	Topbar: {
		en: {
			Profile: "Profile",
		},
		fr: {
			Profile: "Profil",
		},
	},
	Archive: {
		en: {
			archive: "Archive",
			purchases: "PURCHASES",
			sales: "SALES",
			banks: "BANKS",
			taxes: "TAXES",
			vat: "VAT",
			"my docs": "My Docs",
			reference: "Reference",
			name: "Name",
			created: "Created",
			new: "New",
			count: "Count",
			"create folder": "Create Folder",
			page: "Page",
			"view file": "View File",
			"download file": "Download File",
			"move file": "Move",
			"delete file": "Delete",
			"view original file": "View original file",
			"download original file": "Download original file",
			"An error has occurred. Please try again!": "An error has occurred. Please try again!",
		},
		fr: {
			archive: "Archive",
			purchases: "ACHATS",
			sales: "VENTES",
			banks: "FINANCIERS",
			taxes: "IMPÔTS",
			vat: "TVA",
			"my docs": "Mes Documents",
			reference: "Référence",
			name: "Nom",
			created: "Créé",
			new: "Nouveau",
			count: "Compteur",
			"create folder": "Créer un dossier",
			page: "Page",
			"view file": "Afficher le fichier",
			"download file": "Télécharger le fichier",
			"move file": "Déplacer le fichier",
			"delete file": "Supprimer le fichier",
			"view original file": "Afficher le fichier d'origine",
			"download original file": "télécharger le fichier d'origine",
		},
	},
	MySafe: {
		en: {
			"my safe": "My Safe",
			today: "Today",
			daily: "Daily",
			yearly: "Yearly",
			"from reference": "From Reference",
			"starting balance": "Starting Balance",
			"final balance": "Final Balance",
			"print documents": "Print Documents",
			explanation: "Explanation",
			revenue: "Revenue",
			expense: "Expense",
			new: "New",
			save: "Save",
			date: "Date",
			balance: "Balance",
			month: "Month",
			year: "Year",
		},
		fr: {
			"my safe": "Ma caisse",
			today: "Aujourd’hui",
			daily: "Quotidien",
			yearly: "Annuel",
			"from reference": " À partir de la référence",
			"starting balance": "Solde de départ",
			"final balance": "Solde final",
			"print documents": "Imprimer les documents",
			explanation: "Explication",
			revenue: "Revenu",
			expense: "Dépense",
			new: "Nouveau",
			save: "Sauvegarder",
			date: "Date",
			balance: "Balance",
			month: "Mois",
			year: "Année",
		},
	},
	Trash: {
		en: {
			trash: "Trash",
			name: "Name",
			location: " Location",
			"date deleted": "Date Deleted",
			"item type": "Item Type",
			restore: "Restore",
			"delete forever": "Delete Forever",
			"empty trash": "Empty Trash",
			search: "Search",
			"empty trash now": "Empty Trash now",
			"documents that have been in trash more than 30 days will be automatically":
				"Documents that have been in Trash more than 30 days will be automatically",
			deleted: "deleted",
			"text Document": "Text Document",
			"file folder": "File Folder",
		},
		fr: {
			trash: "Poubelle",
			name: "Nom",
			location: "Emplacement",
			"date deleted": "Date de suppression",
			"item type": "Type d’article",
			restore: "Restaurer",
			"delete forever": "Supprimer définitivement",
			"empty trash": "Vider la corbeille",
			search: "Rechercher",
			"empty trash now": "Vider la corbeille maintenant",
			"documents that have been in trash more than 30 days will be automatically":
				"Les documents qui ont été dans la corbeille plus de 30 jours seront automatiquement",
			deleted: "supprimés",
			"text Document": "Document texte",
			"file folder": "Dossier de fichiers",
		},
	},
	Account: {
		en: {
			account: "Account",
			personal: "Personal",
			"my account": "My Account",
			settings: "Settings",
			"log out": "Log out",
			company: "Company",
			information: "Information",
			people: "People",
			plans: "Plans",
			"account basics": "Account Basics",
			name: "Name",
			username: " Username",
			"access type": "Access Type",
			Member: "Member",
			Administrator: "Administrator",
			"work information": "Work Information",
			"job title": "Job Title",
			contact: "Contact",
			email: "Email",
			phone: "Phone",
			password: "Password",
			"change password": "Change Password",
			"use a password at least 8 characters long which includes letters, numbers, and symbols.":
				" Use a password at least 8 characters long which includes letters, numbers, and symbols",
			"current password": "Current Password",
			"new password": "New Password",
			"confirm new password": "Confirm New Password",
			save: "Save",
			notifications: "Notifications",
			"mobile push notifications": " Mobile push notifications",
			"receive push notifications on messages and reminders via your mobile app":
				"Receive push notifications on messages and reminders via your mobile app",
			"desktop push notifications": "Desktop push notifications",
			"receive push notifications on messages and reminders immediately via your desktop app":
				"Receive push notifications on messages and reminders immediately via your desktop app",
			"email push notifications": " Email push notifications",
			"receive email updates on messages and reminders":
				"Receive email updates on messages and reminders",
			preferences: " Preferences",
			language: "Language",
			appearance: " Appearance",
			"customize how METI Box looks on your device": " Customize how METI Box looks on your device",
			light: "Light",
			dark: "Dark",
			specialties: " Specialties",
			location: " Location",
			"client since": " Client Since",
			"add new member": "Add New Member",
			remove: "Remove",
			"archive period": " Archive Period",
			"The period which your accounts of PURCHASES, SALES, and VAT will be examined by your accountants.":
				"The period which your accounts of PURCHASES, SALES, and VAT will be examined by your accountants.",
			"Please contact with your accountant to change your Archive Period.":
				"Please contact with your accountant to change your Archive Period.",
			"box archive": "Box Archive",
			"safe locking period": " Safe Locking Period",
			"The period which your safe to be locked. You will get notifications about your upcoming safe locking deadlines.":
				"The period which your safe to be locked. You will get notifications about your upcoming safe locking deadlines.",
			"weeks safe": "Weeks Safe",
			"month safe": "Month Safe",
			"inactivated safe": "Inactivated Safe",
		},
		fr: {
			account: "Compte",
			personal: "Personnel",
			"my account": "Mon compte",
			settings: "Paramètres",
			"log out": "Se déconnecter",
			company: "Société",
			information: "Information",
			people: "People",
			plans: "Plans",
			"account basics": "Compte basic",
			name: "Nom",
			username: " Nom d’utilisateur",
			"access type": "Type d’accès",
			Member: "Membre",
			Administrator: "Administrateur",
			"work information": "Renseignements sur le travail",
			"job title": "Titre du poste",
			contact: "Contact",
			email: "Email",
			phone: "Téléphone",
			password: "Mot de passe",
			"change password": "Changer le mot de passe",
			"use a password at least 8 characters long which includes letters, numbers, and symbols.":
				" Utilisez un mot de passe d’au moins 8 caractères comprenant des lettres, des chiffres et des symboles",
			"current password": "Mot de passe actuel",
			"new password": "Nouveau mot de passe",
			"confirm new password": "Confirmer le nouveau mot de passe",
			save: "Sauvegarder",
			notifications: "Notifications",
			"mobile push notifications": "Notifications push sur le mobile",
			"receive push notifications on messages and reminders via your mobile app":
				"Recevez des notifications push sur les messages et les rappels via votre application mobile",
			"desktop push notifications": "Notifications push sur ordinateur",
			"receive push notifications on messages and reminders immediately via your desktop app":
				"Recevez des notifications push sur les messages et les rappels immédiatement sur votre ordinateur",
			"email push notifications": "Notifications push par e-mail",
			"receive email updates on messages and reminders":
				"Recevoir des mises à jour par email sur les messages et les rappels",
			preferences: "Préférences",
			language: "Langue",
			appearance: "Apparence",
			"customize how METI Box looks on your device":
				"Personnaliser l’apparence de METI Box sur votre appareil",
			light: "Clair",
			dark: "Foncé",
			specialties: "Spécialités",
			location: "Emplacement",
			"client since": "Client depuis",
			"add new member": "Ajouter un nouveau membre",
			remove: "Enlever",
			"archive period": "Période d’archivage",
			"The period which your accounts of PURCHASES, SALES, and VAT will be examined by your accountants.":
				"La période pendant laquelle vos comptes d’ACHATS, de VENTES et de TVA seront examinés par vos comptables.",
			"Please contact with your accountant to change your Archive Period.":
				"Veuillez contacter votre comptable pour modifier votre période d’archivage.",
			"box archive": "Archive de la box",
			"safe locking period": " Période de verrouillage de la caisse",
			"The period which your safe to be locked. You will get notifications about your upcoming safe locking deadlines.":
				"La période pendant laquelle votre caisse doit être verrouillée. Vous recevrez des notifications sur vos prochaines échéances de verrouillage sécurisé.",
			"weeks safe": "Caisse hebdomadaire",
			"month safe": "Caisse mensuelle",
			"inactivated safe": "Caisse inactive",
		},
	},
};

export default dictionary;
